// extracted by mini-css-extract-plugin
export default {"wrapper":"TerminalWindow_wrapper__skwV9","window":"TerminalWindow_window__kS6aB","body":"TerminalWindow_body__g0oWP"};